export const socialsData = {
  github: "",
  facebook: "https://www.facebook.com/dominika.mroz.3",
  linkedIn: "",
  instagram: "https://www.instagram.com/dominika_mroz_fizjo/",
  codepen: "",
  twitter: "",
  reddit: "",
  blogger: "",
  medium: "",
  stackOverflow: "",
  gitlab: "",
  youtube: "",
};
